<template>
  <header class="header">
    <img class="gradient-bg" src="@/assets/icons/gradient_bg-3x.png" alt="" />
    <h2 class="chat-title">ChatMind</h2>
    <!-- <img class="chat-mask" src="@/assets/icons/chat_mask@3x.png" alt="" /> -->
    <p class="title">
      Write anything & get all solutions with powerful AI - ChatMind.
    </p>
    <img class="ai-avater" src="@/assets/icons/share_web_icon-3x.png" alt="" />
  </header>
</template>

<script>
export default {
  name: "header-comp",
};
</script>

<style lang="scss" scoped>
.header {
  height: 245px;
  position: relative;
  .gradient-bg {
    position: absolute;
    top: 0;
    left: 0;
    height: 159px;
    width: 100%;
  }
  .chat-title {
    padding-top: 40px;
    padding-left: 20px;
    height: 55px;
    font-size: 46px;
    font-style: normal;
    text-align: left;
    color: #fff;
    z-index: 1;
    position: relative;
  }
  .chat-mask {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 173px;
  }
  .title {
    position: absolute;
    top: 160px;
    left: 20px;
    height: 32px;
    width: 213px;
    font-size: 14px;
    font-style: italic;
    color: rgba(107, 122, 153, 1);
    text-align: left;
  }
  .ai-avater {
    position: absolute;
    top: 82px;
    right: 20px;
    width: 120px;
  }
}
</style>
